// extracted by mini-css-extract-plugin
export default {"external":"aYxLlQ","tag":"bYxLlQ","text":"cYxLlQ","block":"dYxLlQ"};